import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FormEvent, Fragment, useState } from "react";
import { Button, Form, FormControl, InputGroup, Modal, Spinner } from "react-bootstrap";
import Quota, { IQuota } from "../../models/quota";
import FormControlFeedback from "../FormControlFeedback";
interface Props {
  quota: IQuota;
  onUpdated?: (quota: IQuota) => void;
}
const EditQuota: React.FC<Props> = ({ quota: qu, onUpdated }) => {
  const [quota, setQuota] = useState(qu);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [shown, setShown] = useState(false);
  const saveChanges = async () => {
    try {
      const updateQuota = new Quota(quota);
      setLoading(true);
      await updateQuota.Update();
      setLoading(false);
      setShown(false);
      if (onUpdated) {
        onUpdated(quota);
      }
    } catch (error) {
      setLoading(false);
      setError(error);
      console.error(error);
    }
  };
  const formSave = async (event: FormEvent) => {
    event.preventDefault();
    await saveChanges();
  };
  return (
    <Fragment>
      <button
        title="Rediger kvote"
        className="blank-button"
        onClick={() => setShown(true)}
      >
        <FontAwesomeIcon icon={faEdit} />
      </button>

      <Modal show={shown} onHide={() => setShown(false)}>
        <form onSubmit={formSave}>
          <Modal.Title>Rediger kvote</Modal.Title>
          <Modal.Body>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Virksomhed</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  readOnly={true}
                  defaultValue={quota.company.name}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Brugere</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlFeedback
                  type="number"
                  errors={error}
                  field="users"
                  defaultValue={quota.users}
                  onChange={(value: string) =>
                    setQuota({ ...quota, users: +value })
                  }
                />
              </InputGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" disabled={loading} type="submit">
              Gem {loading && <Spinner animation="border" size="sm" />}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setQuota(qu);
                setShown(false);
              }}
            >
              Luk
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};

export default EditQuota;
